'use client';

import Image from 'next/image';
import { motion } from 'framer-motion';
import { useIsDesktop } from '@/shared/lib/react/useIsDesktop';
import { Typography } from '@/shared/ui/atoms';
import * as S from './styles';

interface FeatureCardProps {
  index: number;
  description: {
    eyebrow: string;
    title: string;
    description: string;
  };
}

const FeatureCard = ({ index, description }: FeatureCardProps) => {
  const { eyebrow, title, description: descriptionText } = description;
  const baseImageUrl = process.env.NEXT_PUBLIC_BASE_IMAGE_URL;
  const isLg = useIsDesktop();
  const imageUrl = `${baseImageUrl}/medicontents/landing/feature0${index + 1}${isLg ? '' : '-m'}.png`;

  return (
    <motion.div
      key={`feature-${index}`}
      className={S.card}
      initial={{ y: 55, opacity: 0 }}
      whileInView={{ y: 0, opacity: 1 }}
      viewport={{ once: true, amount: 0.25 }}
      transition={{ duration: 0.7, ease: 'easeOut', delay: 0 }}
    >
      <div className={S.content}>
        <Typography as="p" className={S.eyebrow}>
          {eyebrow}
        </Typography>
        <Typography as="p" className={S.title}>
          {title}
        </Typography>
        <Typography as="p" className={S.description}>
          {descriptionText}
        </Typography>
      </div>
      <div className={S.imageWrap}>
        <Image src={imageUrl} alt={`feature-${index + 1}`} fill sizes="32.84rem" className={S.image} />
      </div>
    </motion.div>
  );
};

export default FeatureCard;
